import { createSelector } from "reselect";
import getFloor from "../floor_getters/get_floor";

const getPhotoAreaId = createSelector([
  getFloor
], (floor) => floor?.photoAreaId || null);

export default getPhotoAreaId;
